import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { PersonPlusFill } from 'react-bootstrap-icons';
import CrearProveedorModal from './componentes/crearProveedorModal';
import '../styles/tables.css';
import TablaProveedor from './componentes/tablaProveedor';

function AdminProveedores() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className='mx-2 mt-3'>
      <div className='d-flex flex-column flex-md-row align-items-center justify-content-between'>
        <p className='mb-2 mb-md-0'>
          Administra tus proveedores, gestiona su informacion y sus facturas.
        </p>
        <div className='d-flex mt-2 mt-md-0'>
          <Button variant='danger' onClick={handleShow}>
            <PersonPlusFill /> Nuevo Proveedor
          </Button>
        </div>
      </div>

      {/* MODAL CREAR PROVEEDORES */}
      <CrearProveedorModal show={show} handleClose={handleClose} />

      {/* TABLA DE PROVEEDORES */}
      <div className='my-2'>
        <TablaProveedor />
      </div>
    </div>

  );
}

export default AdminProveedores;
